<ng-content select="span"></ng-content>
<span class="sr-only">{{ srText }}</span>
<span #textLabel class="cmx-button-text-label"><ng-content></ng-content></span>